import React, { useEffect } from 'react';

/**
 * Componente de alerta reutilizable
 * @param {string} type - Tipo de alerta: 'error', 'success', 'warning', 'info'
 * @param {string} message - Mensaje a mostrar
 * @param {function} onClose - Función para cerrar la alerta
 * @param {number} autoClose - Tiempo en milisegundos para auto-cerrar (0 = no auto-cerrar)
 * @param {boolean} showCloseButton - Mostrar botón de cerrar (default: true)
 */
const Alert = ({ 
  type = 'info', 
  message, 
  onClose, 
  autoClose = 0,
  showCloseButton = true,
  placement = 'inline'
}) => {
  
  // Auto-cerrar si está configurado
  useEffect(() => {
    if (autoClose > 0 && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoClose);

      return () => clearTimeout(timer);
    }
  }, [autoClose, onClose, message]);

  // No renderizar si no hay mensaje
  if (!message) return null;

  // Configuración según el tipo de alerta
  const alertConfig = {
    error: {
      className: 'alert-error',
      icon: 'fa-exclamation-circle'
    },
    success: {
      className: 'alert-success',
      icon: 'fa-check-circle'
    },
    warning: {
      className: 'alert-warning',
      icon: 'fa-exclamation-triangle'
    },
    info: {
      className: 'alert-info',
      icon: 'fa-info-circle'
    }
  };

  const config = alertConfig[type] || alertConfig.info;
  const isCentered = placement === 'centered';
  const alertClassName = `modern-alert ${config.className}${isCentered ? ' modern-alert-centered' : ''}`;

  return (
    <div className={alertClassName} role="alert" aria-live="polite">
      <div className="alert-content">
        <i className={`fa ${config.icon}`}></i>
        <span>{message}</span>
      </div>
      {showCloseButton && onClose && (
        <button 
          type="button" 
          className="alert-close"
          onClick={onClose}
          aria-label="Close alert"
        >
          <i className="fa fa-times"></i>
        </button>
      )}
    </div>
  );
};

export default Alert;

